import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { MenuModel } from '../models/menu.model';
import { UserAuth } from '../models/user.auth.model';
import { ComunService } from './comun.service';
import { SeguridadService } from './seguridad.service';

@Injectable({
  providedIn: 'root'
})
export class PublicNavigationDataService {
  private readonly menuItemsSubject = new BehaviorSubject<MenuModel[]>([]);
  private readonly isAuthenticateSubject = new BehaviorSubject<boolean>(false);
  private readonly nameMenuSubject = new BehaviorSubject<string>('');
  private hasInitialized = false;

  readonly menuItems$: Observable<MenuModel[]> = this.menuItemsSubject.asObservable();
  readonly isAuthenticate$: Observable<boolean> = this.isAuthenticateSubject.asObservable();
  readonly nameMenu$: Observable<string> = this.nameMenuSubject.asObservable();

  constructor(
    private comunService: ComunService,
    private seguridadService: SeguridadService
  ) {}

  ensureInitialized(): void {
    if (this.hasInitialized) {
      return;
    }

    this.hasInitialized = true;
    this.loadMenu();
    this.bindAuthenticationState();
  }

  private loadMenu(): void {
    this.comunService.getMenu().subscribe({
      next: (response) => {
        this.menuItemsSubject.next(response);
      },
      error: (error) => {
        console.log(error);
      }
    });
  }

  private bindAuthenticationState(): void {
    const isAuthenticate = this.seguridadService.isAuthenticated();
    this.isAuthenticateSubject.next(isAuthenticate);

    if (!isAuthenticate) {
      this.nameMenuSubject.next('');
      return;
    }

    this.seguridadService.refreshSessionData();
    this.seguridadService.user$.subscribe((usuario) => {
      this.updateUserState(usuario);
    });
    this.seguridadService.getObsUser().subscribe((usuario) => {
      this.updateUserState(usuario);
    });
  }

  private updateUserState(usuario: UserAuth | null | undefined): void {
    if (!usuario) {
      this.nameMenuSubject.next('');
      return;
    }

    this.isAuthenticateSubject.next(true);
    this.nameMenuSubject.next(
      usuario.names.substring(0, 1) + '.' + usuario.lastNames.substring(0, 1)
    );
  }
}
